import React, { Suspense } from 'react';
import { Container } from 'geniebook-ui/dist';
import { BackgroundContainer } from '@assets/styles/background.style';
import MinichatFloatingButtonWrapper from '@components/genieask/MinichatFloatingButtonWrapper';
import WorksheetMinichat from 'genieask/mini-chat';
import { useAtom } from 'jotai';
import {
  clickFloatingButtonAtom,
  showCompleteWorksheetAtom,
} from '@atom/worksheetAtom';
import { WorksheetPopoverProps } from '@models/types/genieask.type';
import { fullChatGenieaskUrl, triggerBtn } from './WorksheetDashboardPage';

const WorksheetCompletedDetail = React.lazy(
  () => import('geniesmart/WorksheetCompletedDetail'),
);

const WorksheetCompletedDetailPage = () => {
  const [showCompleteWorksheet] = useAtom(showCompleteWorksheetAtom);
  const [discussQuestionProps, setDiscussQuestionProps] =
    React.useState<WorksheetPopoverProps>();
  const [clickFloatingButton, setClickFloatingButton] = useAtom(
    clickFloatingButtonAtom,
  );

  const onDiscussQuestionClick = (param: WorksheetPopoverProps) => {
    setDiscussQuestionProps(param);
    setClickFloatingButton(!clickFloatingButton);
  };

  return (
    <BackgroundContainer className={'h-[calc(100vh-68px)]'}>
      <Container className={'max-lg:pt-6 lg:pt-10'}>
        <Suspense>
          <WorksheetCompletedDetail
            onDiscussQuestionClick={onDiscussQuestionClick}
          />

          <MinichatFloatingButtonWrapper>
            <WorksheetMinichat
              trigger={triggerBtn}
              initialScreen={showCompleteWorksheet ? 'worksheet' : 'mini-chat'}
              fullChatUrl={fullChatGenieaskUrl()}
              {...(discussQuestionProps
                ? { worksheet: discussQuestionProps }
                : {})}
            />
          </MinichatFloatingButtonWrapper>
        </Suspense>
      </Container>
    </BackgroundContainer>
  );
};

export default WorksheetCompletedDetailPage;
